export default __webpack_public_path__ + "flag.svg";